import {
  Clock,
  CreditCard,
  Languages,
  Plane,
  Receipt,
  ShieldCheck,
  Tag,
  UserCheck,
} from "lucide-react";
import { useLang } from "../i18n";
import { Eyebrow, Reveal } from "./Reveal";

const ICONS = [Receipt, CreditCard, Languages, Tag, Clock, Plane, ShieldCheck, UserCheck];

export default function WhyChooseUs() {
  const { t } = useLang();
  return (
    <section className="bg-cream py-24 lg:py-28">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
        <Reveal>
          <Eyebrow>{t.why.eyebrow}</Eyebrow>
          <h2
            data-testid="why-heading"
            className="mt-5 font-serif text-4xl text-[#141414] sm:text-5xl"
          >
            {t.why.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {t.why.items.map((w, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={w.t} delay={(i % 4) * 0.07} className="h-full">
                <div
                  data-testid={`why-card-${i + 1}`}
                  className="h-full rounded-2xl border border-black/5 bg-white p-7 shadow-sm transition-shadow hover:shadow-md"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-gold/10 text-gold">
                    <Icon className="h-5 w-5" />
                  </span>
                  <h3 className="mt-7 font-serif text-xl text-[#141414]">
                    {w.t}
                  </h3>
                  <p className="mt-2 text-sm text-gray-500">{w.d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
